import { OptionItem } from '../../../diagram/utils/option-item';
import { TriggerRuleType } from './enum/trigger-rule-type';
import { EnumChangeValue } from './enum/enum-change-value';
var TriggerRuleHelper = /** @class */ (function () {
    function TriggerRuleHelper() {
    }
    TriggerRuleHelper.getTriggerRuleTypes = function () {
        return [
            new OptionItem(TriggerRuleType.Threshold, 'Threshold'),
            new OptionItem(TriggerRuleType.Deviance, 'Deviance')
        ];
    };
    TriggerRuleHelper.getTriggerRuleFromChangeValue = function () {
        return [
            new OptionItem(EnumChangeValue.Value0, 'Value0'),
            new OptionItem(EnumChangeValue.Value1, 'Value1'),
            new OptionItem(EnumChangeValue.Change, 'ValueChange')
        ];
    };
    return TriggerRuleHelper;
}());
export { TriggerRuleHelper };
